import { TgvKatalog } from './tiergruppe.model';

export const areTkvBreedsLoaded = (catalog: TgvKatalog): boolean =>
  catalog.dogBreeds.length > 0 && catalog.horseBreeds.length > 0 && catalog.catBreeds.length > 0;

export const areThhBreedsLoaded = (catalog: TgvKatalog): boolean =>
  catalog.thhDogBreeds.length > 0 && catalog.thhHorseBreeds.length > 0;

export const areIllnessesLoaded = (catalog: TgvKatalog): boolean =>
  catalog.animalIllnesses !== null;

export const areTkvListsLoaded = (catalog: TgvKatalog): boolean =>
  areTkvBreedsLoaded(catalog) && areIllnessesLoaded(catalog);
